"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundamentalData = void 0;
class FundamentalData {
    constructor(obj) {
        for (const prop in obj) {
            const lowercaseName = prop.substr(0, 1).toLocaleLowerCase() + prop.substr(1);
            this[lowercaseName] = obj[prop];
        }
    }
}
exports.FundamentalData = FundamentalData;
//# sourceMappingURL=FundamentalData.js.map